
<template>
	<div class="list_empty">
		<div>
			<img src="../resource/empty.png" alt="" />
			<div>暂无数据</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {},
		methods: {

		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.list_empty{
		width: 100%;
		padding: 280*@vm_base 0;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		color: #999;
		font-size: 28*@vm_base;
		div{
			img{
				width: 200*@vm_base;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/empty.vue